import { Directive, input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { ChangeDependentValidator } from "./changedependentvalidator";

@Directive({
    selector: '[maxValue]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxValueValidatorDirective, multi: true }],
    standalone: true
})

export class MaxValueValidatorDirective extends ChangeDependentValidator implements Validator {
    readonly maxValue = input<number | Date>(undefined);

    constructor() {
        super(['maxValue']);
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const controlValueExists: boolean = control.value !== null && control.value !== undefined;
        const maxValue = this.maxValue();
        const maxValueProvided: boolean = maxValue !== null && maxValue !== undefined;
        const error: ValidationErrors = controlValueExists && maxValueProvided && control.value > this.maxValue()
            ? { "max": `Number cannot be more than ${this.maxValue()}` }
            : null;
        return error;
    }
}